import OrderDetails from './order-details.component'

export default OrderDetails
